/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_2_TitleInputs */

const en_mk_parts_2_title = /** @type {(inputs: Mk_Parts_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat, one channel per division`)
};

const id_mk_parts_2_title = /** @type {(inputs: Mk_Parts_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim per divisi`)
};

/**
* | output |
* | --- |
* | "Team chat, one channel per division" |
*
* @param {Mk_Parts_2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_2_title = /** @type {((inputs?: Mk_Parts_2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_2_title(inputs)
	return en_mk_parts_2_title(inputs)
});